import { render, staticRenderFns } from "./HotelsPage.vue?vue&type=template&id=99e5dfc8&scoped=true"
import script from "./HotelsPage.vue?vue&type=script&lang=js"
export * from "./HotelsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e5dfc8",
  null
  
)

export default component.exports